import React, { useState } from 'react';

import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  List,
  ListItem,
  Typography,
} from '@mui/material';

import { getRegionCodes } from '@luxuryescapes/lib-regions';

import { WHITE_LABELS, brandsByValue } from '~/consts/brands';

interface Props {
  open: boolean;
  currentBrand: string;
  currentRegion: string;
  onClose: () => void;
  onSave: (extraBrands: string[]) => void;
}

function BrandReplicationDialog({ open, currentBrand, currentRegion, onClose, onSave }: Props) {
  const targetBrands = WHITE_LABELS.filter((b) => b !== currentBrand);
  const [selectedBrands, setSelectedBrands] = useState<string[]>([]);

  const handleToggle = (brand: string) => {
    setSelectedBrands((prev) => (prev.includes(brand) ? prev.filter((b) => b !== brand) : [...prev, brand]));
  };

  const handleSave = () => {
    onSave(selectedBrands);
    setSelectedBrands([]);
  };

  const handleClose = () => {
    setSelectedBrands([]);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Save List Order</DialogTitle>
      <DialogContent>
        <Typography variant="body2" gutterBottom>
          Also apply to other brands?
        </Typography>
        <List dense disablePadding>
          {targetBrands.map((brand) => {
            const brandInfo = brandsByValue[brand];
            const isSupported = getRegionCodes(brand as Parameters<typeof getRegionCodes>[0]).includes(currentRegion);

            return (
              <ListItem key={brand} disableGutters>
                <FormControlLabel
                  disabled={!isSupported}
                  control={
                    <Checkbox
                      checked={isSupported && selectedBrands.includes(brand)}
                      onChange={() => handleToggle(brand)}
                    />
                  }
                  label={
                    isSupported ? (
                      (brandInfo?.title ?? brand)
                    ) : (
                      <Typography variant="body2" color="text.disabled">
                        {brandInfo?.title ?? brand} — region {currentRegion} not supported
                      </Typography>
                    )
                  }
                />
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="text">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default BrandReplicationDialog;
